/**
 * チャット（SSE）の `type: "error"` イベントを、画面に出す 1 文にする（agest-inc/ai_assist#1257）。
 *
 * error イベントは次の 3 種類が流れてくる。
 * - ai_assist（#1257 以降）: `{ type: "error", error_code, message, request_id, thread_id, success: false, ... }`。
 *   `message` は利用者向けの固定文言（例外の文字列はサーバのログにだけ残る）
 * - #1257 より前の ai_assist: `{ type: "error", message: <例外の文字列> }`（OpenAI のエラー本文・接続先など）
 * - ai_sstf_controller の中継: `{ type: "error", message: "Backend returned error: 500" }`、
 *   "Backend service timed out"、httpx の例外文、"An unexpected error occurred"（英語の内部文言）
 *
 * `error_code` の付いたもの（＝利用者向けに作られた文言）だけ `message` を見せ、それ以外は固定の文言にする。
 * `request_id` があれば、問い合わせのときに伝えられるよう末尾に付ける。
 */

export const CHAT_STREAM_ERROR_FALLBACK_MESSAGE =
  "AI の応答を受け取れませんでした。しばらくしてから、もう一度送信してください。";

const MAX_MESSAGE_LENGTH = 200;
const REQUEST_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export function isChatStreamErrorEvent(chunk: unknown): boolean {
  return (
    !!chunk &&
    typeof chunk === "object" &&
    (chunk as { type?: unknown }).type === "error"
  );
}

export function chatStreamErrorMessage(chunk: unknown): string {
  const event = (chunk && typeof chunk === "object" ? chunk : {}) as {
    error_code?: unknown;
    message?: unknown;
    request_id?: unknown;
  };
  const message =
    typeof event.message === "string" ? event.message.trim() : "";
  const hasErrorCode =
    typeof event.error_code === "string" && event.error_code.trim() !== "";
  const base =
    hasErrorCode && message && message.length <= MAX_MESSAGE_LENGTH
      ? message
      : CHAT_STREAM_ERROR_FALLBACK_MESSAGE;

  const requestId =
    typeof event.request_id === "string" ? event.request_id.trim() : "";
  return REQUEST_ID_PATTERN.test(requestId)
    ? `${base}（エラーID: ${requestId}）`
    : base;
}
